module.exports = __webpack_public_path__ + "img/pic-3.da8df295.png";